import { Button } from '@mui/material';
import { Content } from 'components/Modal';
import { Link } from 'react-router-dom';
import { ROUTES } from 'constants/routes';
import TertiaryButton from 'components/TertiaryButton';
import Spinner from 'components/Loader';
import { Title, Text, StyledModal, Message, StyledErrorIcon } from './ThirdPartyCodeReveal.styles';

interface CurrentViewProps {
  isLoading: boolean;
  hasError: boolean;
  onClose: () => void;
  onReveal: () => void;
}

type ControlProps = Pick<CurrentViewProps, 'onClose' | 'onReveal'>;

interface ThirdPartyCodeRevealProps extends CurrentViewProps {
  isOpen: boolean;
}

const Loader = () => (
  <Message>
    <Title variant="h2">Just a second</Title>
    <Spinner />
  </Message>
);

const Error = ({ onClose, onReveal }: ControlProps) => (
  <Message>
    <Title variant="h2">Oops, Houston we have a problem.</Title>
    <Text variant="h6" gutterBottom>
      There was an error processing your Perkz
    </Text>
    <StyledErrorIcon />
    <Button fullWidth variant="contained" onClick={onReveal}>
      Try again
    </Button>
    <TertiaryButton fullWidth onClick={onClose}>
      Try later
    </TertiaryButton>
  </Message>
);

const Reveal = ({ onClose, onReveal }: ControlProps) => (
  <>
    <Title variant="h2" gutterBottom>
      Are you sure you want to reveal now?
    </Title>
    <Text variant="h6" gutterBottom>
      Your code must be used by the end of the&nbsp;day
    </Text>
    <Button variant="contained" fullWidth onClick={onReveal}>
      Yes, reveal now
    </Button>
    <TertiaryButton
      fullWidth
      color="primary"
      component={Link}
      to={ROUTES.PERKZ_WALLET}
      onClick={onClose}
    >
      Save for later
    </TertiaryButton>
  </>
);

const CurrentView = (props: CurrentViewProps) => {
  const { isLoading, hasError, onClose, onReveal } = props;

  if (hasError) return <Error onClose={onClose} onReveal={onReveal} />;

  if (isLoading) return <Loader />;

  return <Reveal onClose={onClose} onReveal={onReveal} />;
};

const ThirdPartyCodeReveal = (props: ThirdPartyCodeRevealProps) => {
  const { isOpen, onClose } = props;

  return (
    <StyledModal open={isOpen} onClose={onClose} aria-label="Reveal Code Modal" closeType="none">
      <Content>
        <CurrentView {...props} />
      </Content>
    </StyledModal>
  );
};

export default ThirdPartyCodeReveal;
